import { render, staticRenderFns } from "./SearchBarAlt.vue?vue&type=template&id=5a3f0beb"
import script from "./SearchBarAlt.vue?vue&type=script&lang=js"
export * from "./SearchBarAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports